
import React from 'react';

const ChevronsUpIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" d="m17 11-5-5-5 5" />
        <path strokeLinecap="round" strokeLinejoin="round" d="m17 18-5-5-5 5" />
    </svg>
);

export default ChevronsUpIcon;
